const containerShortFaq = document.querySelector('.js-short-faq')

if(containerShortFaq){
  const allAccordions = containerShortFaq.querySelectorAll('.js-accordion')

  const closeAllAccordions = () => {
    allAccordions.forEach((accordion) => {
      accordion.setAttribute('aria-expanded', 'false')
      accordion.classList.remove('is-open')

      const id = accordion.getAttribute('id')?.replace('_id', '')
      const accordionBody = containerShortFaq.querySelector(`#${id}`)
      if (accordionBody != null) {
        accordionBody.classList.remove('is-open')

        // Clear height to allow smooth transition
        accordionBody.style.maxHeight = `${accordionBody.scrollHeight}px`
        requestAnimationFrame(() => {
          accordionBody.style.maxHeight = '0px'
        })
      }
    })
  }

  allAccordions.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const id = accordion.getAttribute('id')?.replace('_id', '')
      const accordionBody = containerShortFaq.querySelector(`#${id}`)
      if (!accordionBody) {
        return
      }

      const isOpen = accordion.classList.contains('is-open')

      closeAllAccordions()

      if (!isOpen) {
        accordion.setAttribute('aria-expanded', 'true')
        accordion.classList.add('is-open')
        accordionBody.classList.add('is-open')

        // Animate open
        accordionBody.style.maxHeight = '0px'
        requestAnimationFrame(() => {
          accordionBody.style.maxHeight = `${accordionBody.scrollHeight}px`
        })
      }
    })
  })
}